module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"access_date":"Дата доступа","remove_user":"Удалить пользователя"},"en":{"access_date":"Access date","remove_user":"Remove user"}}')
  delete Component.options._Ctor
}
